import {ListDecorator} from './base/ListDecorator';
import {Store} from '@ngrx/store';
import {IAppStore} from '@app/store';
import {PODomain} from '../model/PODomain';
import {of} from 'rxjs';
import {translate} from '@ngneat/transloco';

export class PODomainListDecorator extends ListDecorator {
  isDelBtn$ = of(false);
  isEditBtn$ = of(true);
  isAddBtn$ = of(false);
  docKey = 'domain';
  sortIDs = {
    id: true,
    label: true,
  };

  constructor(public store: Store<IAppStore>) {
    super(PODomain.type);

    const {tPrefix} = this;
    const mainTPrefix = `${tPrefix}domain.`;
    this.title = `${mainTPrefix}title`;
    const translationFields = [
      'delTitle',
      'oneItemTitle',
      'oneItemNewTitle',
      'oneItemNotFound',
    ];
    this.translateTitleFields(mainTPrefix, translationFields);
    const headerCaptions = {
      id: translate('ID'),
      label: translate(`${mainTPrefix}label`),
    };
    this.headerCaptions$ = of(headerCaptions);
    const headers = ['id', 'label'];
    this.headers$ = of(headers);
  }
}
